export function getTeamFromURL() {
    const inAppPath = window.location.pathname.replace(import.meta.env.VITE_BASE_PATH, '');
    return inAppPath.split('/')[1];
}
